var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EqsAlert',{attrs:{"text":_vm.$t('auth.email-confirmation.txt')}}),_c('EqsCard',_vm._b({},'EqsCard',{ loading: _vm.loading },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }